<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="px-8 flex flex-col gap-4">
      <div class="flex justify-center">
        <img
          src="@/assets/images/booking-management/shipping-cart.png"
          alt="shipping cart"
        />
      </div>
      <div class="flex justify-center mt-4">
        <h1 class="text-2xl font-semibold">Add Receiver</h1>
      </div>

      <form @submit.prevent="searchLocation">
        <div class="mt-6 flex gap-4 items-center justify-center">
          <div>
            <label class="label w-full text-center"
              >Who are you sending this shipment to?</label
            >
            <div class="w-full flex mt-1 gap-4 justify-center">
              <div class="mr-8">
                <label for="forSelf" class="radio-label">
                  <input
                    class="bg-primary-yellow text-secondary-yellow"
                    name="first"
                    type="radio"
                    id="forSelf"
                    value="No"
                    v-model="person"
                  />
                  Select Previous Receiver
                  <span></span>
                </label>
              </div>

              <div class="">
                <label for="forOthers" class="radio-label">
                  <input
                    type="radio"
                    v-model="person"
                    value="Yes"
                    id="forOthers"
                    name="first"
                  />
                  Add New Receiver
                  <span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="mt-6" >
        <label class="label">Select from customer’s previous consignee</label>
        <div class="flex gap-4 items-center mt-3 mb-4">
          <div class="w-full">
            <el-select
              class="w-full"
              v-model="recieverLocationId"
              placeholder="Search Shipping Location"
              :disabled="person == 'Yes'"
            >
              <el-option
                v-for="location in deliveryLocations"
                :key="location.id"
                :label="location.contactName || '---'"
                :value="location.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <base-button
          :disabled="disableContinuation"
          text="Continue"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      addresses: [],
      person: "No",
      address: "",

      recieverLocationId: null,
      selectedTakeoffLocationId: "",
      shipment: "",
      deliveryLocations: [],

      deliveryAddress: "",
      consigneeCount: "",
      destinationType: "",
      requestLoading: false,
      loading: false,
    };
  },
  watch: {
    recieverLocationId(val) {
      let filteredLocation = this.deliveryLocations.filter(
        (item) => val == item.id
      )[0];
      this.$emit("setWithPreviousReciever", filteredLocation);
    },

    deliveryAddress(val) {
      if (val) {
        this.selectedTakeoffLocationId = "";
      }
    },
  },
  computed: {
    payload() {
      return {
        userId: this.$store.getters.userId,
        type: "delivery",
      };
    },
    disableContinuation() {
      if (
        this.deliveryAddress != "" ||
        this.selectedTakeoffLocationId != "" ||
        this.person == "Yes" ||
        this.recieverLocationId != null
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async getDeliveryLocations() {
      try {
        const response = await this.$_getRecieverLocations(this.payload);
        this.deliveryLocations = response.data.data.locations;
        console.log("locations response", this.deliveryLocations)
      } catch (error) {
        this.handleError(error);
      }
    },
    submit() {
      this.loading = true;
      let selectedTakeoffLocation = this.addresses.find((location) => {
        return location.id == this.recieverLocationId;
      });

      let lastForm = 0;
      if (selectedTakeoffLocation) {
        this.$store.dispatch(
          "saveSelectedShipperLocation",
          selectedTakeoffLocation
        );
        this.handleTakeoffActions(selectedTakeoffLocation);
        lastForm = 1;
      }

      this.loading = false;
      this.$store.dispatch("saveLastCompletedFormNo", lastForm);
      this.$router.push({ name: "BookingFlow" });
      this.closeModal();
    },
    handleTakeoffActions(location) {
      const shipper = { ...this.$store.getters.shipperInformation };
      delete shipper.userId;
      delete shipper.updatedAt;
      delete shipper.createdAt;
      delete shipper.id;
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: shipper,
      });
      this.$store.dispatch("saveTakeOffLocationId", location.id);
    },
    async searchLocation() {
      this.requestLoading = true;
      try {
        const response = await this.$_searchLocationByName(this.shipment);
        this.requestLoading = false;
        this.addresses = response.data.data.locations;
        if (this.addresses.length) {
          this.address = this.addresses[0];
        }
        this.log(response);
      } catch (error) {
        this.requestLoading = false;
        this.handleError(error);
      }
    },
    disableButton() {
      if (this.shipment.length > 0) {
        return false;
      }
      return true;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    this.getDeliveryLocations();
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
